// Enhance the prerendered document; never mount React over static page content.
export function enableStaticInteractions() {
  document.documentElement.dataset.adcRuntime = 'islands';
  const button = document.querySelector('.menu-toggle');
  const overlay = document.querySelector('.nav-mobile-overlay');
  const header = document.querySelector('.site-header');
  const top = document.getElementById('backToTop');
  let requestedSection = window.location.hash.slice(1) || null;
  const setMenu = open => {
    if (!button || !overlay) return;
    button.classList.toggle('active', open); overlay.classList.toggle('active', open);
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    document.body.style.overflow = open ? 'hidden' : '';
  };
  button?.addEventListener('click', () => setMenu(!overlay?.classList.contains('active')));
  overlay?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') setMenu(false); });
  top?.addEventListener('click', () => {
    const root=document.documentElement;root.style.scrollBehavior='auto';document.body.style.scrollBehavior='auto';window.scrollTo(0,0);
    requestAnimationFrame(()=>{root.style.scrollBehavior='';document.body.style.scrollBehavior='';});
  });
  document.querySelectorAll('a[href^="/#"]').forEach(a => a.addEventListener('click', event => {
    if (window.location.pathname !== '/') return;
    const id=a.getAttribute('href').slice(2), target=document.getElementById(id);
    if (!target) return;
    event.preventDefault();requestedSection=id;window.history.replaceState(window.history.state,'','/#'+id);
    window.scrollTo({top:target.getBoundingClientRect().top+window.scrollY-72,behavior:'smooth'});setMenu(false);updateScroll();
  }));
  function updateScroll() {
    const y=window.scrollY;
    const isHome=window.location.pathname==='/';
    if (!isHome) {
      if(header && header.classList.contains('is-scrolled')!==(y>10))header.classList.toggle('is-scrolled',y>10);
      if(top && top.classList.contains('show')!==(y>300))top.classList.toggle('show',y>300);
      return;
    }
    let active=requestedSection || 'accueil';
    if (!requestedSection && y>=80) {
      const line=Math.min(Math.max((header?.getBoundingClientRect().bottom||0)+24,window.innerHeight*.35),window.innerHeight*.8);
      const sections=['services','apropos','contact'].map(id=>document.getElementById(id)).filter(Boolean);
      active=sections.filter(n=>n.getBoundingClientRect().top<=line).pop()?.id||'accueil';
    }
    if(header && header.classList.contains('is-scrolled')!==(y>10))header.classList.toggle('is-scrolled',y>10);
    if(top && top.classList.contains('show')!==(y>300))top.classList.toggle('show',y>300);
    document.querySelectorAll('.nav-link,.nav-mobile-link').forEach(a=>{
      const id=a.getAttribute('href')==='/'?'accueil':a.getAttribute('href')?.slice(2);
      if(a.classList.contains('is-active')!==(id===active))a.classList.toggle('is-active',id===active);
    });
  }
  let frame;
  window.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=null;updateScroll();});},{passive:true});
  ['wheel','touchmove','keydown'].forEach(name=>window.addEventListener(name,()=>{requestedSection=null;},{passive:true}));
  // Prerendered initial header is already correct; avoid forcing layout before paint.
  window.addEventListener('pageshow',event=>{if(event.persisted)requestAnimationFrame(updateScroll);});
  document.querySelectorAll('.faq-question').forEach(question=>{
    question.setAttribute('aria-expanded','false');
    question.addEventListener('click',()=>{
      const item=question.closest('.faq-item'), answer=item?.querySelector('.faq-answer');if(!answer)return;
      const open=question.getAttribute('aria-expanded')!=='true';
      if(item.closest('.city-faq,.service-faq'))item.parentElement.querySelectorAll('.faq-item').forEach(other=>{
        other.classList.remove('is-open');other.querySelector('.faq-question')?.setAttribute('aria-expanded','false');
        const a=other.querySelector('.faq-answer');if(a){a.classList.remove('is-open');a.style.maxHeight='0px';}
      });
      item.classList.toggle('is-open',open);answer.classList.toggle('is-open',open);answer.style.maxHeight=open?'1000px':'0px';question.setAttribute('aria-expanded',String(open));
    });
  });
  document.querySelectorAll('.map-load-button[data-map-url]').forEach(button=>button.addEventListener('click',()=>{
    const iframe=document.createElement('iframe');iframe.title=button.dataset.mapTitle||'Localisation';iframe.src=button.dataset.mapUrl;iframe.width='100%';iframe.height='100%';iframe.style.border='0';iframe.referrerPolicy='no-referrer-when-downgrade';iframe.allowFullscreen=true;button.replaceWith(iframe);
  }));
  const reveal=[...document.querySelectorAll('.reveal-on-scroll')];
  if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}}),{threshold:.15});reveal.forEach(n=>observer.observe(n));}
  else reveal.forEach(n=>n.classList.add('is-visible'));
  const contact=document.getElementById('contact');
  if(contact){let started=false;const activate=()=>{if(started)return;started=true;import('./contactIsland').then(module=>module.hydrateContact(contact)).catch(()=>{started=false;});};
    contact.addEventListener('pointerdown',activate,{once:true,capture:true});contact.addEventListener('focusin',activate,{once:true,capture:true});
    if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();activate();}},{rootMargin:'400px'});observer.observe(contact);}else activate();
  }
}
